import roomInfoPanelTemplate from "App/pages/roomInfoPanel.html";
import Utils from "App/js/utils";

const HTTP_URL = /^https?:\/\//i;

export default class RoomInfoPanel {
  constructor(container) {
    this.container = container;
    this.host = null;
    this.button = null;
    this.window = null;
    this.content = null;
    // Na stronie startowej (okladka, intro) przycisk ma nie istniec wizualnie.
    // Odblokowuje go dopiero start() wolany po rozpoczeciu spaceru.
    this.started = false;
  }

  mount() {
    if (!this.container) {
      return;
    }

    const host = document.createElement("div");
    host.className = "room-info";
    host.innerHTML = roomInfoPanelTemplate;
    this.container.appendChild(host);

    this.host = host;
    this.button = host.querySelector(".room-info-button");
    this.window = host.querySelector(".room-info-window");

    Utils.registerEvent(this.button, "click", () => this.toggle());
    Utils.registerEvent(host.querySelector(".room-info-close"), "click", () =>
      this.hide()
    );

    document.addEventListener("click", (event) => {
      if (this.isHidden()) return;
      if (host.contains(event.target)) return;
      // Po zadokowaniu przycisk zyje poza hostem, wiec bez tego warunku
      // wlasne klikniecie zamykaloby okno tuz po jego otwarciu.
      if (this.button && this.button.contains(event.target)) return;
      this.hide();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") this.hide();
    });
  }

  /**
   * Przenosi przycisk na poczatek belki z akcjami czatu, czyli tuz przed
   * glosnik. Odstepy i breakpointy zalatwia flexbox rodzica - dlatego
   * dokujemy do DOM zamiast liczyc offsety w CSS.
   * Wolane po zamontowaniu czatu; bez czatu przycisk zostaje w rogu.
   */
  dockTo(container) {
    if (!container || !this.button) {
      return;
    }

    container.insertBefore(this.button, container.firstChild);
    Utils.addClass(this.button, "room-info-button--docked");
  }

  /**
   * Odblokowuje przycisk po rozpoczeciu spaceru. Wolane bezwarunkowo,
   * niezaleznie od tego, czy czat istnieje i czy udalo sie zadokowac.
   */
  start() {
    this.started = true;
    this.applyVisibility();
  }

  applyVisibility() {
    if (!this.button) {
      return;
    }

    if (this.started && this.hasContent(this.content)) {
      Utils.removeClass(this.button, "hidden");
    } else {
      Utils.addClass(this.button, "hidden");
    }
  }

  /**
   * Tresc jest jedna na caly spacer - bierzemy ja z konfiguracji projektu,
   * a nie ze zdjecia, wiec ustawiamy ja raz, nie przy kazdej zmianie sceny.
   */
  setContent(source) {
    if (!this.host) {
      return;
    }

    this.content = source;
    this.hide();
    this.applyVisibility();

    if (this.hasContent(source)) {
      this.render(source);
    }
  }

  hasContent(source) {
    if (!source) return false;
    const hasTitle = !!(source.RoomInfoTitle || "").trim();
    const hasText = !!(source.RoomInfoText || "").trim();
    const hasLinks = (source.RoomInfoLinks || []).length > 0;
    return hasTitle || hasText || hasLinks;
  }

  render(source) {
    // textContent, nigdy innerHTML - tresc pochodzi od uzytkownika panelu
    // i nie moze byc interpretowana jako znaczniki.
    this.window.querySelector(".room-info-title").textContent =
      source.RoomInfoTitle || "";
    this.window.querySelector(".room-info-text").textContent =
      source.RoomInfoText || "";

    const links = this.window.querySelector(".room-info-links");
    while (links.firstChild) {
      links.removeChild(links.firstChild);
    }

    const inWebview = Utils.getParameterValue("wv", null) != null;

    (source.RoomInfoLinks || []).forEach((link) => {
      if (!HTTP_URL.test(link.Url || "")) {
        return;
      }
      const anchor = document.createElement("a");
      anchor.className = "room-info-link";
      anchor.href = link.Url;
      anchor.target = inWebview ? "_top" : "_blank";
      anchor.rel = "noopener noreferrer";
      anchor.textContent = link.Label || link.Url;
      links.appendChild(anchor);
    });
  }

  isHidden() {
    return !this.window || this.window.classList.contains("hidden");
  }

  toggle() {
    if (this.isHidden()) {
      Utils.removeClass(this.window, "hidden");
    } else {
      this.hide();
    }
  }

  hide() {
    if (this.window) {
      Utils.addClass(this.window, "hidden");
    }
  }
}
